









































import Vue from 'vue'
import Component from 'vue-class-component'
import { getModule } from 'vuex-module-decorators'
import { compositionToUrlQuerySpec } from '@/utils/composition.ts'

import CategoriesTable from '@/components/CategoriesTable.vue'
import PointsTable from '@/components/PointsTable.vue'
import JsonBlock from '@/components/JsonBlock.vue'

import Compositions from '@/store/compositions.ts'

const compositions = getModule(Compositions)

@Component({
  components: {
    CategoriesTable,
    PointsTable,
    JsonBlock
  }
})
export default class TablesPanel extends Vue {
  get currentCompositionSpec () {
    return compositionToUrlQuerySpec(compositions.current)
  }
  get currentComposition () {
    return compositions.current
  }
  get allCompositions () {
    return compositions.asArray
  }
}

